import assign from 'lodash/assign';
import { ApiService } from 'services/api.service';
import { CheckoutService } from 'services/checkout.service';
import { CreditCardService } from 'services/creditCard.service';

import { CreditCardForm } from 'components/creditCardForm/creditCardForm';
import { SaveAndCancel } from 'components/saveAndCancel/saveAndCancel';
import { AddressForm } from 'components/addressForm/addressForm';

import { DisplayBillingAddress } from '../displayBillingAddress/displayBillingAddress';
import template from './savedPaymentMethod.html';
import './savedPaymentMethod.scss';

export const SavedPaymentMethod = angular
    .module('checkout.components.editAccountPayment.savedPaymentMethod', [
        ApiService,
        CheckoutService,
        CreditCardForm,
        AddressForm,
        SaveAndCancel,
        DisplayBillingAddress,
        CreditCardService
    ]).component('savedPaymentMethod', {
        template,
        bindings: {
            paymentMethod: '<',
            onPaymentMethodSaved: '<',
            onPaymentMethodDeleted: '<',
            showDeleteButton: '<',
            isMobile: '<'
        },
        controller: class SavedPaymentMethodCtrl {
            constructor(
                apiService,
                checkoutService,
                creditCardService,
                $rootScope
            ) {
                assign(this, {
                    apiService,
                    checkoutService,
                    creditCardService,
                    $rootScope
                });
            }

            $onInit() {
                this.unbindListener = this.$rootScope.$on('editAccountPayment:Editing', (event, data) => {
                    if (data !== this.paymentMethod.id) this.onCancelClicked();
                });
            }

            $onDestroy() {
                this.unbindListener();
            }

            $onChanges(changesObj) {
                if (changesObj.paymentMethod && !changesObj.paymentMethod.isFirstChange()) {
                    this.setModels(changesObj.paymentMethod.currentValue);
                }
            }

            setModels(paymentMethod) {
                this.creditCardModel = {
                    cardNumber: `**** **** **** ${paymentMethod.lastFour}`,
                    expiration: `${paymentMethod.expiration.month}/${paymentMethod.expiration.year}`
                };
                this.billingAddressModel = {
                    name: paymentMethod.name,
                    address1: paymentMethod.address.line1,
                    address2: paymentMethod.address.line2,
                    city: paymentMethod.address.city,
                    state: paymentMethod.address.state,
                    postalCode: paymentMethod.address.zip,
                    country: paymentMethod.address.country
                };
                this.isDefault = paymentMethod.isDefault;
            }

            onEditClicked() {
                this.isEditing = true;
                this.setModels(this.paymentMethod);
                this.$rootScope.$emit('editAccountPayment:Editing', this.paymentMethod.id);
            }

            onCancelClicked() {
                this.isEditing = false;
                this.showDeleteConfirm = false;
                this.showBillingAddressForm = false;
                this.setModels(this.paymentMethod);
            }

            onCancelDeleteClicked() {
                this.showDeleteConfirm = false;
            }

            onConfirmDeleteClicked() {
                this.isDeleting = true;
                return this.apiService.account.paymentMethod.delete(this.paymentMethod.id)
                    .then(() => {
                        return this.onPaymentMethodDeleted();
                    }).finally(() => {
                        this.isDeleting = false;
                    });
            }

            onDeleteClicked() {
                this.showDeleteConfirm = true;
            }

            onSaveClicked() {
                if (this.editPaymentMethodForm.$invalid) {
                    this.checkoutService.forceFormValidation(this.editPaymentMethodForm['$ctrl.addressForm']);
                    this.checkoutService.forceFormValidation(this.editPaymentMethodForm['$ctrl.creditCardForm']);
                    return;
                }

                this.isSaving = true;
                const expirationObj = this.creditCardService.convertExpStringToObject(this.creditCardModel.expiration);
                const card = {
                    ...this.paymentMethod,
                    isDefault: this.isDefault,
                    address: {
                        line1: this.billingAddressModel.address1,
                        line2: this.billingAddressModel.address2,
                        city: this.billingAddressModel.city,
                        state: this.billingAddressModel.state,
                        zip: this.billingAddressModel.postalCode,
                        country: this.billingAddressModel.country
                    },
                    expiration: {
                        month: expirationObj.expMonth,
                        year: expirationObj.expYear
                    },
                    name: this.billingAddressModel.name

                };

                return this.apiService.account.paymentMethod.update(this.paymentMethod.id, card)
                    .then(() => {
                        return this.onPaymentMethodSaved().then(() => {
                            this.isEditing = false;
                            this.showDeleteConfirm = false;
                            this.showBillingAddressForm = false;
                        });
                    }).finally(() => {
                        this.isSaving = false;
                    });
            }

            onChangeBillingAddressClicked() {
                this.showBillingAddressForm = true;
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/editAccountPayment/savedPaymentMethod/savedPaymentMethod.js